<script>
    import Highcharts from "highcharts";
    import { userHasPremium, userLoggedIn } from "../Stores";
    import { fetchDataResults, dataVizTypes } from "../Constants";
    import {
        fetchIFEFieldSpots,
        fetchIFEFieldPerDistrictSpots,
        fetchIFEFieldInDistrictSpots,
        fetchAllFields,
        fetchAllDistricts,
        fetchIFELastFieldSpots,
    } from "./DataVizServerCommunications";
    import {
        buildFieldSpotsPerYearSeries,
        buildFieldSpotsPerDistrictSeries,
        buildFieldSpotsInDistrictSeries,
        buildFieldSpotsPerYearConfig,
        buildFieldSpotsPerDistrictConfig,
        buildFieldSpotsInDistrictConfig,
        buildLastFieldSpotsConfig,
    } from "./HighchartsUtils";

    let fetchDataResult = fetchDataResults.SUCCESS;

    let selectedDataViz = dataVizTypes.LAST_SPOTS_PER_YEAR;

    let allFields = [];
    let allYears = [];
    let allDistricts = [];

    let selectedField;
    let selectedYear;
    let selectedDistrict;

    let fieldSpotsPerYear;
    let fieldSpotsPerYearSeries;
    let fieldSpotsPerYearCanvas;

    let fieldSpotsPerDistrict;
    let fieldSpotsPerDistrictSeries;
    let fieldSpotsPerDistrictCanvas;

    let fieldSpotsInDistrict;
    let fieldSpotsInDistrictSeries;
    let fieldSpotsInDistrictCanvas;

    let lastFieldSpotsCanvas;

    async function updateCharts() {
        switch (selectedDataViz) {
            case dataVizTypes.LAST_SPOTS_PER_YEAR:
                updateLastSpotsPerYearChart();
                break;
            case dataVizTypes.SPOTS_PER_YEAR:
                updateFieldSpotsPerYearChart();
                break;
            case dataVizTypes.SPOTS_PER_DISTRICT_IN_YEAR:
                updateFieldSpotsPerDistrictChart();
                break;
            case dataVizTypes.SPOTS_PER_YEAR_IN_DISTRICT:
                updateFieldSpotsInDistrictChart();
                break;
        }
    }

    async function updateFieldSpotsPerYearChart() {
        fieldSpotsPerYear = await fetchIFEFieldSpots(selectedField);

        if (!selectedYear) {
            allYears = Object.keys(fieldSpotsPerYear);
            selectedYear = allYears[allYears.length - 1];
        }

        fieldSpotsPerYearSeries =
            buildFieldSpotsPerYearSeries(fieldSpotsPerYear);
        let chartConfig = buildFieldSpotsPerYearConfig(
            fieldSpotsPerYearSeries,
            fieldSpotsPerYear,
            selectedField,
        );
        Highcharts.chart(fieldSpotsPerYearCanvas, chartConfig);
    }

    async function updateFieldSpotsPerDistrictChart() {
        fieldSpotsPerDistrict =
            await fetchIFEFieldPerDistrictSpots(selectedField);
        if (!selectedYear) {
            allYears = Object.keys(fieldSpotsPerDistrict);
            selectedYear = allYears[allYears.length - 1];
        }
        fieldSpotsPerDistrictSeries = buildFieldSpotsPerDistrictSeries(
            fieldSpotsPerDistrict[selectedYear],
        );

        let chartConfig = buildFieldSpotsPerDistrictConfig(
            fieldSpotsPerDistrictSeries,
            fieldSpotsPerDistrict[selectedYear],
            selectedField,
            selectedYear,
        );

        Highcharts.chart(fieldSpotsPerDistrictCanvas, chartConfig);
    }

    async function updateFieldSpotsInDistrictChart() {
        fieldSpotsInDistrict = await fetchIFEFieldInDistrictSpots(
            selectedField,
            selectedDistrict,
        );
        fieldSpotsInDistrictSeries =
            buildFieldSpotsInDistrictSeries(fieldSpotsInDistrict);

        let chartConfig = buildFieldSpotsInDistrictConfig(
            fieldSpotsInDistrictSeries,
            fieldSpotsInDistrict,
            selectedField,
            selectedDistrict,
        );

        Highcharts.chart(fieldSpotsInDistrictCanvas, chartConfig);
    }

    async function updateLastSpotsPerYearChart() {
        let lastFieldSpots = await fetchIFELastFieldSpots(selectedField);
        let chartConfig = buildLastFieldSpotsConfig(
            lastFieldSpots,
            selectedField,
        );

        Highcharts.chart(lastFieldSpotsCanvas, chartConfig);
    }

    async function fetchData() {
        if ($userLoggedIn) {
            if ($userHasPremium) {
                allFields = await fetchAllFields();
                allDistricts = await fetchAllDistricts();
                selectedField = allFields[0];
                selectedDistrict = "Lisboa";
                await updateCharts();
                fetchDataResult = fetchDataResults.SUCCESS;
            } else {
                fetchDataResult = fetchDataResults.USER_NOT_PREMIUM;
            }
        } else {
            fetchDataResult = fetchDataResults.USER_NOT_LOGGED_IN;
        }
    }

    $: $userHasPremium,
        $userLoggedIn,
        (async () => {
            await fetchData();
        })();

    $: selectedField,
        selectedDataViz,
        (async () => {
            await updateCharts();
        })();
    $: selectedYear,
        (async () => {
            await updateFieldSpotsPerDistrictChart();
        })();
    $: selectedDistrict,
        (async () => {
            await updateFieldSpotsInDistrictChart();
        })();
</script>

{#if fetchDataResult === fetchDataResults.SUCCESS}
    <div id="dataVizDiv">
        <select
            id="dataVizSelect"
            class=" rounded-md text-black mb-2 p-2 focus:outline-none max-w-full"
            bind:value={selectedDataViz}
        >
            {#each Object.entries(dataVizTypes) as [dataVizType, dataVizTitle]}
                <option value={dataVizTitle}>{dataVizTitle}</option>
            {/each}
        </select>

        <select
            id="dataVizSelect"
            class=" rounded-md text-black mb-2 p-2 focus:outline-none max-w-full"
            bind:value={selectedField}
        >
            {#each allFields as field}
                <option value={field}>{field}</option>
            {/each}
        </select>
        {#if selectedDataViz == dataVizTypes.LAST_SPOTS_PER_YEAR}
            <div id="lastFieldSpotsChart" bind:this={lastFieldSpotsCanvas} />
        {/if}

        {#if selectedDataViz == dataVizTypes.SPOTS_PER_YEAR}
            <div
                id="fieldSpotsPerYearChart"
                bind:this={fieldSpotsPerYearCanvas}
            />
        {/if}

        {#if selectedDataViz == dataVizTypes.SPOTS_PER_DISTRICT_IN_YEAR}
            <select
                id="dataVizSelect"
                class=" rounded-md text-black p-2 focus:outline-none max-w-full"
                bind:value={selectedYear}
            >
                {#each allYears as year}
                    <option value={year}>{year}</option>
                {/each}
            </select>
            <div
                id="fieldSpotsPerDistrictChart"
                bind:this={fieldSpotsPerDistrictCanvas}
            />
        {/if}

        {#if selectedDataViz == dataVizTypes.SPOTS_PER_YEAR_IN_DISTRICT}
            <select
                id="dataVizSelect"
                class=" rounded-md text-black p-2 focus:outline-none max-w-full"
                bind:value={selectedDistrict}
            >
                {#each allDistricts as district}
                    <option value={district}>{district}</option>
                {/each}
            </select>
            <div
                id="fieldSpotsInDistrictChart"
                bind:this={fieldSpotsInDistrictCanvas}
            />
        {/if}
    </div>
{:else if fetchDataResult === fetchDataResults.USER_NOT_LOGGED_IN}
    <p id="warningText">
        Precisas de criar uma conta para acederes a este conteúdo!
    </p>
{:else}
    <p>Precisas de uma conta premium para aceder a este conteúdo!</p>
{/if}

<style>
    * {
        font-size: small;
    }

    @media (min-width: 360px) {
        * {
            font-size: medium;
        }
    }

    #warningText {
        margin-top: 4rem;
        margin-bottom: 100%;
        width: 100%;
        text-align: center;
    }

    #dataVizDiv {
        margin-top: 4rem;
        display: flex;
        flex-direction: column;
        align-items: start;
    }

    #dataVizSelect {
        width: max-content;
    }

    #fieldSpotsPerDistrictChart,
    #fieldSpotsInDistrictChart,
    #fieldSpotsPerYearChart,
    #lastFieldSpotsChart {
        margin-top: 0.75rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        max-width: 1500px;
        border-radius: 0.375rem;
    }

    #fieldSpotsPerDistrictChart,
    #fieldSpotsInDistrictChart {
        height: 30rem;
    }
</style>
